import React from 'react';
import { Line } from 'react-chartjs-2';
import { map, concat, merge } from 'lodash';
import { colors, line, defaultDatasetKeyProvider } from '../ChartDefaults';
import moment from 'moment';

class IncrementalLineChart extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			//data: this.buildChartData(props.data),
			options: merge({}, line, props.options)
		};
		this.getData = this.getData.bind(this);
	}
	
	getData(canvas) {
		// return this.props.data;
		let {labels, datasets} = this.props.data;
		if(!datasets)
			return this.props.data;
			
		for(let row of datasets) {
			if(Array.isArray(row.data)) {
				const incrementalArray = [...row.data]; 
				
				for (let i = 1; i < incrementalArray.length; i++) {
				  incrementalArray[i] = incrementalArray[i] + incrementalArray[i - 1];
				}
				row.data = incrementalArray;
				row.fill = false;
			}
		}
		return {
			labels,
			datasets,
			
		}
		
	}
	
	render() {
		const { data, options, ...rest } = this.props;
		return (this.props.data ? <Line data={this.getData} options={this.state.options} {...rest} datasetKeyProvider={this.props.datasetKeyProvider || defaultDatasetKeyProvider}></Line> : null);
	}
}

export default IncrementalLineChart